import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { formatDateTime } from '../../utils/dateFormat';

const ActivitiesList = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async () => {
    try {
      const { data } = await axios.get('/api/crm/activities');
      setActivities(data.activities);
    } catch (error) {
      toast.error('Failed to fetch activities');
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await axios.patch(`/api/crm/activities/${id}/status`, { status });
      toast.success('Status updated');
      fetchActivities();
    } catch (error) {
      toast.error('Failed to update status');
    }
  };

  const activityTypeColors = {
    Call: 'bg-blue-100 text-blue-800',
    Meeting: 'bg-green-100 text-green-800',
    Email: 'bg-purple-100 text-purple-800',
    'Follow-up': 'bg-yellow-100 text-yellow-800'
  };

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">CRM Activities</h1>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Lead</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Start Time</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {activities.map((activity) => (
              <tr key={activity.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${activityTypeColors[activity.activityType] || 'bg-gray-100 text-gray-800'}`}>
                    {activity.activityType}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <button
                    onClick={() => navigate(`/crm/leads/${activity.leadId}`)}
                    className="text-blue-600 hover:underline"
                  >
                    {activity.lead?.name || 'Unknown'}
                  </button>
                </td>
                <td className="px-6 py-4 max-w-xs truncate">{activity.description || '-'}</td>
                <td className="px-6 py-4">
                  {activity.startTime ? formatDateTime(activity.startTime) : '-'}
                </td>
                <td className="px-6 py-4">
                  <select
                    value={activity.status}
                    onChange={(e) => updateStatus(activity.id, e.target.value)}
                    className={`px-2 py-1 rounded text-xs border ${
                      activity.status === 'Completed' ? 'bg-green-50 border-green-200' :
                      activity.status === 'Cancelled' ? 'bg-red-50 border-red-200' :
                      'bg-yellow-50 border-yellow-200'
                    }`}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                </td>
                <td className="px-6 py-4">
                  <button
                    onClick={() => navigate(`/crm/leads/${activity.leadId}`)}
                    className="text-blue-600 hover:underline"
                  >
                    View Lead
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {activities.length === 0 && (
          <div className="text-center py-8 text-gray-500">No activities found</div>
        )}
      </div>
    </div>
  );
};

export default ActivitiesList;
